





















































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { APICarrier } from '@/models/api/carrier.model'
import { Component, Vue } from 'vue-property-decorator'
import { APIProvider } from '../../models/api/provider.model'
import { APIShortcode } from '../../models/api/shortcode.model'

@Component
export default class ProductsForm extends Vue {
    loading = true;
    data: { [key: string]: unknown } = {};

    cardTitle = '';

    buttonLoading = false;

    formData: { [key: string]: any } = {
        productEnabled: true,
        typeId: {
            id: null
        }
    };

    formValid = false;
    formRules = {
        required: [(v: string) => !!v || 'This field is required'],
        productPeriodicity: [
            (v: string) => !!v || 'This field is required',
            (v: string) =>
                (v && v.toString().length <= 3) ||
                'Field must be less than 3 characters'
        ],
        productMaxDailySubs: [
            // (v: string) => (v && v.toString().length <= 6) || 'Field must be less than 6 characters'
        ],
        productMaxMonthlySubs: [
            // (v: string) => (v && v.toString().length <= 6) || 'Field must be less than 6 characters'
        ],
        name: [
            (v: string) => !!v || 'This field is required',
            (v: string) =>
                (v && v.length <= 128) ||
                'Field must be less than 128 characters'
        ],
        productRetationDays: [
            (v: string | number) => {
                if (v === null || v === undefined || v === '') return true // opcional
                return Number.isInteger(Number(v)) || 'Must be a valid integer'
            },
            (v: string | number) => {
                if (v === null || v === undefined || v === '') return true
                return /^\d+$/.test(String(v)) || 'Only numeric characters are allowed'
            }
        ]
    };

    formModel: {
        providers: APIProvider[];
        shortcodes: APIShortcode[];
        carriers: APICarrier[];
    } = {
        providers: [],
        shortcodes: [],
        carriers: []
    };

    async mounted () {
        if (!this.$route.params.action) {
            this.$store.commit('reportError', {
                code: 1000,
                message: 'Error, not action sended in route params :('
            })
            return
        }

        await Promise.all([
            this.getProviders(),
            this.getShortcodes(),
            this.getCarriers()
        ])

        switch (this.$route.params.action) {
        case 'edit':
            this.cardTitle = 'Edit Product'
            this.getData()
            break
        case 'add':
            this.cardTitle = 'Create Product'
            this.data = {}
            this.loading = false
            break
        }
    }

    getProviders () {
        return new Promise<void>(resolve => {
            this.$store.dispatch('getProviders').then(resp => {
                if (resp.status === 200) {
                    this.formModel.providers = this.$store.state?.ProvidersStore?.providers?.map(
                        (p: APIProvider) => {
                            return {
                                text: p.providerName,
                                value: p.providerId
                            }
                        }
                    )
                    resolve()
                }
            })
        })
    }

    getCarriers () {
        return new Promise<void>(resolve => {
            this.$store.dispatch('getCarriers').then(resp => {
                if (resp.status === 200) {
                    this.formModel.carriers = this.$store.state?.CarriersStore?.carriers?.map(
                        (p: APICarrier) => {
                            return {
                                text: p.carrierName,
                                value: p.carrierId
                            }
                        }
                    )
                    resolve()
                }
            })
        })
    }

    assignShortCodes () {
        this.formModel.shortcodes = this.$store.state?.ShortcodesStore?.shortcodes
            ?.filter?.(
                (
                    v: APIShortcode & {
                        providerId: APIProvider & { carrierId: APICarrier };
                    }
                ) => {
                    return v.providerId.providerId === this.formData.providerId
                }
            )
            ?.map((p: APIShortcode) => {
                return {
                    text: p.shortcode,
                    value: p.shortcodeId
                }
            })
    }

    assignProviders () {
        this.formModel.providers = this.$store.state?.ProvidersStore?.providers
            ?.filter?.((v: APIProvider & { carrierId: APICarrier }) => {
                return v.carrierId.carrierId === this.formData.carrierId
            })
            ?.map((p: APIProvider) => {
                return {
                    text: p.providerName,
                    value: p.providerId
                }
            })
    }

    handleOnChangeCarrier (v: number) {
        if (typeof v !== 'number') return
        this.formData.carrierId = v
        if (this.formModel.shortcodes.length) {
            this.formData.shortcodeId = null
        }
        if (this.formModel.providers.length) {
            this.formData.providerId = null
        }
        this.assignProviders()
        this.assignShortCodes()
    }

    handleOnChangeProviderId (v: number) {
        if (typeof v !== 'number') return
        this.formData.providerId = v
        if (this.formModel.shortcodes.length) {
            this.formData.shortcodeId = null
        }
        this.assignShortCodes()
        this.assignProviders()
    }

    async getShortcodes () {
        await this.$store.dispatch('getShortcodes')
        if (this.formData.providerId) this.assignShortCodes()
        else {
            this.formData.shortcodes = this.$store.state?.ShortcodesStore?.shortcodes
        }
    }

    getData () {
        this.loading = true
        if (!this.$route.params.id) {
            this.$store.commit('reportError', {
                code: 1000,
                message: 'Error, not id sended in route params :('
            })
            this.loading = false
            return
        }
        this.$store
            .dispatch('getProductsById', this.$route.params.id)
            .then(resp => {
                if (resp?.status === 200) {
                    this.formData = this.$store.state.ProductsStore.productForm
                    this.formData.carrierId = this.formData.providerId?.carrierId?.carrierId
                    this.formData.providerId = this.formData.providerId.providerId
                    this.formData.shortcodeId = this.formData.shortcodeId.shortcodeId
                    this.assignProviders()
                    this.assignShortCodes()
                    this.loading = false
                }
            })
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return

        this.buttonLoading = true
        this.formData.productMaxDailySubs = this.formData.productMaxDailySubs
            ? this.formData.productMaxDailySubs
            : 0
        this.formData.productMaxMonthlySubs = this.formData
            .productMaxMonthlySubs
            ? this.formData.productMaxMonthlySubs
            : 0
        this.formData.productFreeTrial = this.formData
            .productFreeTrial
            ? this.formData.productFreeTrial
            : 0
        this.formData.productRetationDays = this.formData
            .productRetationDays
            ? this.formData.productRetationDays
            : null

        switch (this.$route.params.action) {
        case 'edit':
            this.$store
                .dispatch('editProducts', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit(
                            'reportSuccess',
                            'Done Successfully!'
                        )
                        this.$router
                            .push({
                                name: 'Products'
                            })
                            .then(() => {
                                this.buttonLoading = false
                            })
                    }
                })
            break
        case 'add':
            this.$store
                .dispatch('createProducts', this.formData)
                .then(resp => {
                    this.buttonLoading = false
                    if (resp?.status === 200) {
                        this.$store.commit(
                            'reportSuccess',
                            'Done Successfully!'
                        )
                        this.$router
                            .push({
                                name: 'Products'
                            })
                            .then(() => {
                                this.buttonLoading = false
                            })
                    }
                })
            break
        }
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date
            .getDate()
            .toString()
            .padStart(2, '0')
        const month = date
            .getMonth()
            .toString()
            .padStart(2, '0')
        const year = date
            .getFullYear()
            .toString()
            .padStart(4, '0')
        const hours = date
            .getHours()
            .toString()
            .padStart(2, '0')
        const minutes = date
            .getMinutes()
            .toString()
            .padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }
}
